import apiClient from '../api/client';
import { extractErrorMessage } from '../utils/errorHandler';
import i18n from '../i18n';

/**
 * Базовый query function для RTK Query с поддержкой unified response format.
 * Unified формат (согласно CLAUDE.md):
 * - Success: {data: {...}, error: null}
 * - Error: {data: null, error: {...}}
 */
const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: '' }) =>
    async ({ url, method, data, params, responseType, timeout, onUploadProgress }) => {
      try {
        const result = await apiClient({
          url: baseUrl + url,
          method,
          data,
          params,
          responseType, // Поддержка responseType для blob/arraybuffer
          ...(timeout && { timeout }),
          ...(onUploadProgress && { onUploadProgress }),
        });

        // Проверяем, использует ли бэкенд unified формат
        if (result.data && typeof result.data === 'object' && 'data' in result.data && 'error' in result.data) {
          // Unified формат - извлекаем data
          if (result.data.error) {
            // Backend вернул ошибку в unified формате
            return {
              error: {
                status: result.data.error.status || result.status,  // Fallback to HTTP status
                data: result.data.error,
              },
            };
          }
          // Success в unified формате
          return { data: result.data.data };
        }

        // Legacy формат - возвращаем как есть
        return { data: result.data };
      } catch (error) {
        // Проверяем unified формат в ошибке
        const errorData = error.response?.data;
        if (errorData && typeof errorData === 'object' && 'data' in errorData && 'error' in errorData) {
          // Unified формат ошибки
          return {
            error: {
              status: errorData.error.status || error.response?.status,  // Fallback to HTTP status
              data: errorData.error,
            },
          };
        }

        // Legacy формат ошибки
        return {
          error: {
            status: error.response?.status,
            data: errorData || extractErrorMessage(error, i18n.t("errors.requestFailed", { ns: "common" })),
          },
        };
      }
    };

export default axiosBaseQuery;